var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMetamask(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 175,
    viewBox: "0 0 175 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150.557 19.4993L95.9039 60.0909L106.011 36.1424L150.557 19.4993Z",
    fill: "#E2761B",
    stroke: "#E2761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3879 19.4993L78.6017 60.4754L68.9893 36.1424L24.3879 19.4993ZM130.893 113.591L116.337 135.891L147.481 144.46L156.434 114.085L130.893 113.591ZM18.6205 114.085L27.5188 144.46L58.6629 135.891L44.107 113.591L18.6205 114.085Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9052 75.9103L48.2266 89.038L79.1509 90.4112L78.0524 57.1799L56.9052 75.9103ZM118.04 75.9103L96.618 56.7954L95.9039 90.4112L126.773 89.038L118.04 75.9103ZM58.6628 135.891L77.2284 126.828L61.1895 114.305L58.6628 135.891ZM97.7165 126.828L116.337 135.891L113.755 114.305L97.7165 126.828Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M116.337 135.891L97.7165 126.828L99.1996 138.967L99.0348 144.076L116.337 135.891ZM58.6628 135.891L75.9651 144.076L75.8552 138.967L77.2284 126.828L58.6628 135.891Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2398 106.285L60.7501 101.726L71.6808 96.7278L76.2398 106.285ZM98.7052 106.285L103.264 96.7278L114.25 101.726L98.7052 106.285Z",
    fill: "#233447",
    stroke: "#233447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6629 135.891L61.2995 113.591L44.1071 114.085L58.6629 135.891ZM113.701 113.591L116.337 135.891L130.893 114.085L113.701 113.591ZM126.773 89.0381L95.904 90.4113L98.7602 106.285L103.319 96.728L114.305 101.726L126.773 89.0381ZM60.7502 101.726L71.7357 96.728L76.2398 106.285L79.151 90.4113L48.2266 89.0381L60.7502 101.726Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2266 89.0381L61.1895 114.305L60.7501 101.726L48.2266 89.0381ZM114.305 101.726L113.755 114.305L126.773 89.0381L114.305 101.726ZM79.1509 90.4113L76.2397 106.285L79.865 125.016L80.6889 100.353L79.1509 90.4113ZM95.9039 90.4113L94.4208 100.298L95.08 125.016L98.7601 106.285L95.9039 90.4113Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7602 106.285L95.08 125.016L97.7165 126.828L113.755 114.305L114.305 101.726L98.7602 106.285ZM60.7501 101.726L61.1895 114.305L77.2285 126.828L79.865 125.016L76.2398 106.285L60.7501 101.726Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0348 144.076L99.1996 138.967L97.8264 137.759H77.1186L75.8552 138.967L75.9651 144.076L58.6628 135.891L64.7049 140.835L76.9538 149.349H97.9911L110.295 140.835L116.337 135.891L99.0348 144.076Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7166 126.828L95.0801 125.016H79.8651L77.2285 126.828L75.8553 138.967L77.1187 137.759H97.8265L99.1997 138.967L97.7166 126.828Z",
    fill: "#161616",
    stroke: "#161616",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M152.864 62.7275L157.533 40.3169L150.557 19.4993L97.7166 58.7177L118.04 75.9101L146.767 84.3141L153.139 76.8988L150.392 74.9214L154.787 70.9117L151.381 68.2752L155.775 64.9246L152.864 62.7275ZM17.467 40.3169L22.1359 62.7275L19.1698 64.9246L23.564 68.2752L20.2134 70.9117L24.6077 74.9214L21.8613 76.8988L28.178 84.3141L56.9052 75.9101L77.2285 58.7177L24.3879 19.4993L17.467 40.3169Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M146.767 84.3143L118.04 75.9103L126.773 89.0381L113.755 114.305L130.893 114.085H156.434L146.767 84.3143ZM56.9052 75.9103L28.1779 84.3143L18.6205 114.085H44.107L61.1895 114.305L48.2266 89.0381L56.9052 75.9103ZM95.9039 90.4113L97.7165 58.7179L106.066 36.1426H68.9893L77.2285 58.7179L79.1509 90.4113L79.8101 100.408L79.865 125.016H95.08L95.1898 100.408L95.9039 90.4113Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.1bb4747b7e1623a4afcd705f4e9bc496.svg";
export { ForwardRef as ReactComponent };